import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection, endDirection } from 'app/styles/selectors/markup';
import { HEADER_HEIGHT } from 'app/features/header/constants';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.Gradient = styled.div`
  label: Gradient;

  background-image: linear-gradient(
    to bottom,
    var(--colors-honey-gold-bright),
    var(--colors-orange-base)
  );

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-block-start: ${HEADER_HEIGHT};
`;

S.Wrapper = styled.div`
  label: ContentWrapper;

  position: relative;
  margin: 3.75rem 1.25rem 14.1875rem;
  max-width: 45rem;
  z-index: 0;

  @media (${widthSmall}) {
    margin: 3.75rem 3.75rem 15.3125rem;
  }

  @media (${widthMedium}) {
    margin: 6.75rem 22.5rem 12.3125rem;
  }
`;

S.YuzuWraper = styled.div`
  label: YuzuWraper;

  position: absolute;
  ${startDirection}: -4.75rem;
  top: -3rem;

  @media (${widthSmall}) {
    ${startDirection}: -6rem;
    top: -3.43rem;
  }

  @media (${widthMedium}) {
    ${startDirection}: -6.875rem;
    top: -4.3rem;
  }
`;

S.YuzuBackgroundImage = styled.img`
  label: YuzuBackgroundImage;

  position: absolute;
  width: 25rem;
  height: 21.875rem;
  ${startDirection}: -2rem;
  top: -1.25rem;
  z-index: -1;
  object-fit: contain;

  @media (${widthMedium}) {
    ${startDirection}: -7rem;
    top: -1.5rem;
  }
`;

S.YuzuImage = styled.img`
  label: YuzuImage;

  width: 14rem;
  height: 8.75rem;
  object-fit: contain;

  @media (${widthSmall}) {
    width: 17.25rem;
    height: 10rem;
  }

  @media (${widthMedium}) {
    width: 20.1875rem;
    height: 12.4375rem;
  }
`;

S.ChestWraper = styled.div`
  label: ChestWraper;

  position: absolute;
  ${endDirection}: 1.25rem;
  bottom: -14.062rem;

  @media (${widthSmall}) {
    ${endDirection}: -3.31rem;
    bottom: -15.12rem;
  }

  @media (${widthMedium}) {
    ${endDirection}: -15rem;
    bottom: -10.5rem;
  }
`;

S.ChestBackgroundImage = styled.img`
  label: ChestBackgroundImage;

  position: absolute;
  object-fit: contain;
  z-index: -1;
  ${endDirection}: -0.5rem;
  bottom: 8.75rem;
  width: 23.18rem;
  height: 17.62rem;

  @media (${widthSmall}) {
    ${endDirection}: -1.18rem;
    bottom: 3.68rem;
    width: 26.93rem;
    height: 22.3rem;
  }

  @media (${widthMedium}) {
    ${startDirection}: -6.12rem;
    top: -7.68rem;
    width: 26rem;
    height: 19.81rem;
  }
`;

S.ChestImage = styled.img`
  label: ChestImage;

  width: 17.25rem;
  height: 16.375rem;
  object-fit: contain;

  @media (${widthSmall}) {
    width: 19.25rem;
    height: 18.375rem;
  }

  @media (${widthMedium}) {
    width: 20.75rem;
    height: 19.81rem;
  }
`;

S.Content = styled.div`
  label: Content;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding-block: 3.5rem;
  padding-inline: 1.25rem;
  background-color: white;

  @media (${widthSmall}) {
    padding-inline: 7.125rem;
  }

  @media (${widthMedium}) {
    padding-block: 4rem 3.5rem;
    padding-inline: 6.875rem;
  }
`;

S.Button = styled.div`
  label: Button;

  @media (${widthSmall}) {
    height: 3.375rem;
    padding-inline: 1.625rem;
  }
`;

S.CallToAction = styled.span`
  label: CallToAction;

  font-size: 0.875rem;
  line-height: 1.125rem;

  @media (${widthSmall}) {
    font-size: 1.125rem;
    line-height: 1.625rem;
  }
`;

S.ButtonNoThanks = styled.div`
  label: ButtonNoThanks;

  margin-block: 1.31rem 2.1875rem;

  @media (${widthSmall}) {
    margin-block-start: 1.4375rem;
  }

  @media (${widthMedium}) {
    margin-block-end: 2.9375rem;
  }
`;

export default S;
